import { useCompanyAgents } from './useCompanyAgents';

/**
 * Fetches all company call agents.
 * Shares the React Query cache with other company agent hooks.
 */
export const useDashboardAgents = (enabled = true) => {
  return useCompanyAgents(enabled);
};
